<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-2 border-b border-grey">
        <h3
          class="my-0 text-xl font-bold"
          v-text="`${form.attributes.title} Form Submission`"
        />
        <h4
          class="text-xs m-0 text-grey-dark"
          v-text="`Submitted by: ${submission.submitter.attributes.full_name}`"
        />
        <h4
          class="text-xs  m-0 text-grey-dark"
          v-text="`Submitted: ${submission.attributes.submitted_at_diff}`"
        />
      </header>
      <section class="mx-6">
        <ul style="padding-inline-start: 2rem">
          <FormFieldValue
            v-for="field in form.fields.data"
            :key="`custom_field_${field.id}`"
            :field="field"
            :field-label="field.attributes.label"
            :value="submission.attributes[field.attributes.slug]"
          />
        </ul>
      </section>
      <div class="modal-footer text-center mt-8">
        <button
          type="button"
          class="btn btn--sm btn--danger ml-4 "
          @click="close"
          v-text="'Close'"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import {mapState} from 'vuex'
import FormFieldValue from './FormFieldValue'

export default {
  name: 'FormSubmissionDetailsModal',
  components: {
    FormFieldValue,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    submission: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      form: state => state.form.form,
    }),
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
